var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('b-card',{attrs:{"body-class":"pb-50"}},[_c('h6',[_vm._v("Pengajuan Berdasarkan Jenjang")]),_c('vue-apex-charts',{attrs:{"height":"200","options":_vm.data.chartOptions,"series":_vm.data.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }